// CDN assets are served from Lovable hosting at /__l5e/assets-v1/...
// Inside the native app wrapper (Median/Capacitor) the page origin is not the
// Lovable host, so relative asset paths fail to resolve. Always resolve them
// against the published origin.
const ASSET_ORIGIN = 'https://gambgo-food-delivery-app.lovable.app';

export const assetUrl = (url: string): string =>
  url.startsWith('/') ? `${ASSET_ORIGIN}${url}` : url;
